
export const commonFields = {
  employeeId: {
    name: 'employeeId',
    validations: {
      minLength: 1
    }
  },
  nmlsId: {
    name: 'nmlsId',
    validations: {
      matchRegexp: /^[0-9]{0,12}$/
    }
  }
};

export default {
  fields: [
    {
      name: 'firstName',
      validations: {
        minLength: 1
      }
    },
    {
      name: 'lastName',
      validations: {
        minLength: 1
      }
    },
    {
      name: 'email',
      type: 'email',
      validations: {
        isEmail: true
      }
    },
    {
      name: 'phone',
      validations: {
        matchRegexp: /^\([0-9]{3}\)\s*[0-9]{3}-[0-9]{4}$|^[0-9]{10}$/
      }
    },
    commonFields.employeeId
  ],
  required: ['firstName', 'lastName', 'email', 'phone']
};
